import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import Text from '../text/text.component.js';
import { generalBackground } from '../../theme/theme-style.js';
import '../../App.css.js';
var _excluded = ["style", "titleText", "background", "textStyle", "theme", "children"];
var Container = styled.div.withConfig({
  displayName: "banner-blockcomponent__Container",
  componentId: "sc-9e1fyu-0"
})(["width:100%;min-width:100%;display:flex;flex-direction:column;align-items:center;box-sizing:border-box;padding-top:96px;padding-bottom:96px;@media screen and (max-width:768px){padding-top:48px;padding-bottom:48px;}", ""], function (props) {
  return props.color.lastIndexOf("#") >= 0 || props.color.lastIndexOf("var") >= 0 ? "background-color: " + props.color : generalBackground;
});
var TextTitle = styled(Text).withConfig({
  displayName: "banner-blockcomponent__TextTitle",
  componentId: "sc-9e1fyu-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:48px;line-height:57px;}"]);
var BannerBlock = function BannerBlock(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    background = _ref.background;
  _ref.textStyle;
  _ref.theme;
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, _extends({
    color: background,
    style: style
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      maxWidth: "756px",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      paddingLeft: "24px",
      paddingRight: "24px",
      boxSizing: "border-box"
    }
  }, /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "display",
    fontSize: "large",
    color: "var(--white)",
    style: {
      marginBottom: "34px",
      letterSpacing: "-1px"
    }
  }, titleText), children));
};
var bannerBlock_component = withTheme(BannerBlock);
export { bannerBlock_component as default };